import React, { useEffect, useState } from 'react';
// import { currentPollsStyle as styles } from './currentPolls.tailwind';
import { livePollsStyle as styles } from './chat.tailwind';
import { useSelector } from 'react-redux';
import noPollsIcon from '../../../../../../assets/svgs/no_polls.svg';
import PollList from '../../../../shared/Polls/PollList';
import { POLL_DISPLAY_TYPE, RECORD_STATUS } from '../../../../../../lib/constants/globalConstant';
import PollSkeleton from '../../../../shared/Skeletons/PollSkeleton/PollSkeleton';

const LivePollSection = ({ gameId }) => {
  const { livePolls, isLivePollsLoading } = useSelector((state) => state.earnPoint);
  
  const { user } = useSelector((state) => state.user);
  const userId = user?.userDetails?._id;
  
  const [expandedPolls, setExpandedPolls] = useState([0]);
  const [polls, setPolls] = useState([]);

  // Handle the selection of a poll
  const togglePoll = (index) => {
    setExpandedPolls(prev => {
      const isCurrentlyExpanded = prev.includes(index);
      if (isCurrentlyExpanded) {
        // Remove the index if it's already in the array
        return prev.filter(pollIndex => pollIndex !== index);
      } else {
        // Add the index if it's not in the array
        return [...prev, index];
      }
    });
  };

  // New function to handle poll submission
  const handlePollSubmit = (index) => {
    // Add the submitted poll to expanded polls if not already there
    setExpandedPolls(prev => {
      if (!prev.includes(index)) {
        return [...prev, index];
      }
      return prev;
    });
  };

  useEffect(() => {
    if (!livePolls) return; // Ensure livePolls is defined

    if (livePolls?.length > 0) {
      const _filteredPolls = livePolls.filter(poll => {
          if (!poll) return false; // Ignore undefined/null polls

          const isDeleted = poll?.deleteFlag;
          const isInactive = poll?.status !== RECORD_STATUS.ACTIVE;
          // const isNotStarted = poll?.pollStartDateTime ? getTimeStamps(poll?.pollStartDateTime) > getCurrentTimestamps() : false;
          // const isExpired = poll?.pollEndDateTime ? getTimeStamps(poll?.pollEndDateTime) <= getCurrentTimestamps() : false;

          return !(isDeleted || isInactive) && (poll?.displayOnAllLiveGames || poll?.displayOnLiveGame) && (poll?.pollDisplayType === POLL_DISPLAY_TYPE.BOTH || poll?.pollDisplayType === POLL_DISPLAY_TYPE.GAME);
      });

      setPolls(_filteredPolls);
    }
  }, [livePolls]);

  if(isLivePollsLoading){
    return (
      <div className={styles.pollDataContainer}>
        <PollSkeleton isLiveGame={true} />
      </div>
    )
  }

  if (polls?.length === 0) {
    return (
      <div className={styles.noPollsContainer}>
        <img
          src={noPollsIcon}
          alt="No polls"
          className={styles.noPollsIcon}
        />
        <p className={styles.noPollsText}>No Live Polls Found</p>
      </div>
    )
  }
  
  return (
    <div className={styles.outerContainer}>
      <h1 className='text-[14px] font-[300] p-1 screen-500:hidden'>Polls</h1>
      <div className={styles.pollDataContainer}>
        {/* live polls */}
        {polls?.map((poll, index) => ( 
          <PollList
            key={index}
            poll={poll}
            index={index}
            userId={userId}
            gameId={gameId}
            isExpanded={expandedPolls?.includes(index)}
            togglePoll={togglePoll}
            onPollSubmit={handlePollSubmit}
            isLivePoll={true}
          />
        ))}
      </div>
    </div>
  );
};

export default LivePollSection;
